import { render, staticRenderFns } from "./RegistrationUser.vue?vue&type=template&id=096f96dc&scoped=true&"
import script from "./RegistrationUser.vue?vue&type=script&lang=js&"
export * from "./RegistrationUser.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationUser.vue?vue&type=style&index=0&id=096f96dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f96dc",
  null
  
)

export default component.exports